import { ClientSetupBody } from './ClientSetup.Body';
import { ClientSetupFooter } from './ClientSetup.Footer';

/** Compound component for the "Basic info" step. */
export const ClientSetup = {
  Body: ClientSetupBody,
  Footer: ClientSetupFooter,
};
